import { render, staticRenderFns } from "./BankingLanding.vue?vue&type=template&id=2a647127&"
import script from "./BankingLanding.vue?vue&type=script&lang=ts&"
export * from "./BankingLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports